export default "__VITE_PUBLIC_ASSET__52031f94__"